import commonERC20 from './CommonERC20'
import kovan from './kovan/index'
import mainnet from './mainnet/index'
export const abi = {
  42: {
    commonERC20,
    ...kovan
  },
  1: {
    commonERC20,
    ...mainnet
  }
}
export default {
  42: {
    commonERC20,
    ...kovan
  },
  1: {
    commonERC20,
    ...mainnet
  }
}
